export const MODAL_EVENT = {
  SHOW_TRAILER: 'SHOW_TRAILER',
};